import React from "react";
import styled from "styled-components";

export const CategoryHolder = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  width: 100%;
  margin: 15px 0;
  position: relative;
`;

export const CategoryTitle = styled.div`
  height: 41px;
  line-height: 41px;
  font-family: Montserrat;
  font-size: 20px;
  font-weight: 600;
  letter-spacing: 0.5px;
  text-align: left;
  color: #272d67;
  padding: 0 5px;
  @media screen and (max-width: 414px) {
    font-size: 16px;
  }
`;

export const CategorySmallTitle = styled.div`
	height: 41px;
	line-height: 41px;
	background-color; rgba(252, 219, 207, 0.2);
	font-family: Montserrat;
	font-size: 20px;
	font-weight: normal;
	font-style: italic;
	letter-spacing: 0.6px;
	text-align: left;
	color: #272d67;
	padding: 0 5px 0 0;
	@media screen and (max-width: 414px) {
		font-size: 16px;
	}
`;

export const InformationButton = styled.div`
font-size: 21px;
color: #272d67;
cursor: default;
font-family: "Open Sans", Helevetica, Arial, sans-serif
line-height: 15px;
transform: rotate(90deg);
margin-top: 4px;
.info-popup {
	max-width: 414px;
	padding: 2.5% 3%;
	left: 0;
	z-index: 2;
	white-space: pre-line;
	visibility: hidden;
	background: #fff;
	position: absolute;
	box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.1);

	p {
		font-size: 13px;
		color: #323232;
		}

	span {
		font-family: Montserrat, Helevetica, Arial, sans-serif;
		font-size: 14px;
		color: #262e66;
		font-weight: 600;
		}
	}

	&:hover .info-popup {
		visibility: visible;
	}
`;

export const sliderSettings = {
  dots: true,
  infinite: false,
  speed: 250,
  slidesToShow: 3,
  slidesToScroll: 1,
  className: "ha-slider-recommendations recommendations-title-pick",
  arrows:true,
  responsive: [
    {
      breakpoint: 1445,
      settings: {
        slidesToShow: 3,
        slidesToScroll: 1,
        infinite: false,
        dots: true,
        arrows:true,
        className: "ha-slider-recommendations recommendations-title-pick"
      }
    },
    {
      breakpoint: 1327,
      settings: {
        slidesToShow: 3,
        slidesToScroll: 1,
        infinite: false,
        dots: true,
        arrows:true,
        className: "ha-slider-recommendations recommendations-title-pick"
      }
    },
    {
      breakpoint: 1180,
      settings: {
        slidesToShow: 3,
        slidesToScroll: 1,
        infinite: false,
        dots: true,
        arrows:true,
        className: "ha-slider-recommendations recommendations-title-pick"
      }
    },
    {
      breakpoint: 900,
      settings: {
        slidesToShow: 2.4,
        slidesToScroll: 1,
        infinite: false,
        dots: false,
        arrows:false,
        className: "ha-slider-recommendations recommendations-title-pick"
      }
    },

    {
      breakpoint: 768,
      settings: {
        slidesToShow: 2,
        slidesToScroll: 1,
        infinite: false,
        dots: false,
        arrows:false,
        className: "ha-slider-recommendations recommendations-title-pick"
      }
    },


    {
      breakpoint: 552,
      settings: {
        slidesToShow: 1.2,
        slidesToScroll: 1,
        arrows:false,
        className: "ha-slider-recommendations recommendations-title-pick"
      }
    },
    {
      breakpoint: 320,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1,
        arrows:false,
        className: "ha-slider-recommendations recommendations-title-pick"
      }
    }
  ],
  appendDots: () => (
    <div></div>
  )
};

export const ingredientsProdct_SliderSettings = {
  dots: false,
  infinite: false,
  speed: 250,
  slidesToShow: 5,
  slidesToScroll: 1,
  arrows:true,
  responsive: [
    {
      breakpoint: 900,
      settings: {
        slidesToShow: 4,
        slidesToScroll: 1,
        infinite: false,
      }
    },

    {
      breakpoint: 768,
      settings: {
        slidesToShow: 2,
        slidesToScroll: 1,
        infinite: false,
      }
    },
    {
      breakpoint: 320,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1,
      }
    }
  ],
};



// WEBPACK FOOTER //
// ./src/views/recommendations/RecommendationsStyles.js